import MainButton from "../../../components/button/mainButton";
import "../../../assets/styles/admin/opd.scss";
import React, { useState } from "react";
import { mdiPrinter, mdiFileUploadOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { useHistory, useLocation } from "react-router-dom";
import { useEffect } from "react";
import HeaderBar from "../../../components/header/headerBar";

const JOBView = () => {
    const location = useLocation();

    interface Props {
        No: string;
        totalNo: string;
        date: string;
        cn: string;
        name: string;
        course: string;
        branch: string;
        doctorName: string;
        opdStatus?: string;
        onEditDoctor?: () => void;
        onUploadOPD?: () => void;
    }
    const OPDViewCard: React.FC<Props> = ({
        No,
        date,
        cn,
        name,
        course,
        totalNo,
        branch,
        doctorName,
        opdStatus,
        onEditDoctor,
        onUploadOPD,
    }) => {
        const history = useHistory();

        function handleChange(e: React.ChangeEvent<HTMLInputElement>) { }

        function onComplication() {
            history.push(`${location.pathname}/complication/${No}`);
        }

        return (
            <div className="opd-view-card">
                <div className="opd-header">
                    <div>ครั้งที่ {No}</div>
                    <div>{date}</div>
                </div>
                <div className="opd-container">
                    <div className="opd-row">
                        <div className="contant">{cn}</div>
                        <div className="contant">{name}</div>
                    </div>
                    <div className="opd-row">
                        <div className="contant">{course}</div>
                        <div className="contant">{`${No}/${totalNo}`}</div>
                    </div>
                    <div className="opd-row">
                        <div className="contant color-fix">สาขาที่ซื้อ/ใช้</div>
                        <div className="contant">{branch}</div>
                    </div>
                    <div className="opd-row">
                        <div className="contant color-fix">Therapist/Doctor</div>
                        <div className="contant">
                            <div>{doctorName}</div>
                        </div>
                    </div>
                    <div className="opd-row">
                        <div className="contant color-fix">เลขที่ใบยา</div>
                        <div className="contant">
                            <label htmlFor="img">
                                <div id="rounded">
                                    <Icon path={mdiPrinter} size="20" color="#fff" />
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="opd-row">
                        <div className="contant color-fix">ใบเซ็น</div>
                        <div className="contant">
                            <label htmlFor="img-2">
                                <div id="rounded">
                                    <Icon path={mdiPrinter} size="20" color="#fff" />
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="opd-row" style={{ padding: "10px 20px",float:"right" }}>
                        <MainButton
                            title="JOB COST"
                            width="100px"
                            onClick={() => history.push(`/jobcost/list/${No}/view`)}
                        />
                    </div>
                </div>
            </div>
        );
    };
    const opdViewList = [
        {
            no: "1",
        },
    ];
    opdViewList.sort((a, b) => (a.no < b.no ? 1 : -1));
    return (
        <div>
            <HeaderBar title="JOB COST MAIN" btnBack={true}/>
            <div style={{ padding: "0px 40px" }}>
                <div className="opd-view">
                    {opdViewList.map((item, index) => (
                        <OPDViewCard
                            No={item.no}
                            date="14-12-2563"
                            cn="EK-CNF62060025"
                            name="Ms. Alice Watts"
                            course="Hair Transplant FUE"
                            totalNo="300/300"
                            branch="เอกมัย/เอกมัย"
                            doctorName="ดร.อภิชญา ธัญญาวุฒิ"
                            opdStatus=""
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};
export default JOBView;
